import React from 'react';
import { inject, observer } from 'mobx-react';
import { NewBookingsStore, RootStore } from 'AppClient/stores';
import { BookingsStep } from 'AppClient/stores/NewBookingsStore';

interface Props {
	component: any;
	step: BookingsStep;
	newBookingsStore?: NewBookingsStore;
}

const Provider: React.FC<Props> = props => {
	if (props.step === props.newBookingsStore!.step) {
		const { component: Component } = props;
		return <Component />;
	}
	return null;
};

export default inject(({ newBookingsStore }: RootStore) => ({
	newBookingsStore,
}))(observer(Provider));
